/**
 * A marca do momento, resolvida uma vez e compartilhada.
 *
 * Existe para que `brand-boot` (antes do React) e `App` (depois) cheguem à
 * mesma resposta. Duas chamadas independentes divergiriam no instante em que
 * uma delas apagasse o guardado.
 *
 * A ordem, e o porquê de cada degrau, está em `@eva/domain/brand/porta`.
 */
import {
  detectBrand,
  gravarPortaDaAba,
  lerPortaDaAba,
  RESERVED_SUBDOMAINS,
  sessionStore,
  type BrandDetection,
} from '@eva/domain';

import { marcaAdministrativaDaSessao } from './marca-da-sessao';

function resolver(): BrandDetection {
  const daSessao = marcaAdministrativaDaSessao(window.location.pathname, sessionStore.readContext());
  if (daSessao) return daSessao;
  const deteccao = detectBrand({
    hostname: window.location.hostname,
    pathname: window.location.pathname,
    baseDomain: import.meta.env.VITE_BASE_DOMAIN || null,
    devSlug: import.meta.env.VITE_DEV_BRAND_SLUG || null,
    // Fora do painel, a detecção continua respeitando a porta de entrada.
    // A troca explícita entre marcas administrativas é resolvida acima.
    sessionBrandId: sessionStore.readContext()?.brandId ?? null,
    storedSlug: lerPortaDaAba(),
    reserved: RESERVED_SUBDOMAINS,
  });

  if (deteccao.lembrar !== undefined) gravarPortaDaAba(deteccao.lembrar);
  return deteccao;
}

export const marcaDetectada: BrandDetection = resolver();
